<script setup>
import { useWebStore } from '~/store/web'
import MachineryHero from '~/components/MachineryHero.vue'
import IconTextCard from '~/components/IconTextCard.vue'
import MachineryGallery from '~/components/MachineryGallery.vue'
import MachineryReferences from '~/components/MachineryReferences.vue'
import MachinerySectionTitle from '~/components/MachinerySectionTitle.vue'
import CtaBanner from '~/components/CtaBanner.vue'

const props = defineProps({
  topicIndex: { type: Number, required: true },
})

const store = useWebStore()
const machinery = computed(() => store.locale.current.machinery)
const topic = computed(() => machinery.value.topics[props.topicIndex])

// A nyelvváltás a `sites` index-párja alapján dolgozik, ezért a `chosenTab`-nak
// a `children` url-jével kell egyeznie: "<hub-slug>/<topic-slug>".
store.chosenTab = `${machinery.value.slug}/${topic.value.slug}`
</script>

<template>
  <div class="w-full bg-white">
    <MachineryHero
      :title="topic.hero.title"
      :lead="topic.hero.lead"
      :image="topic.hero.image"
      :image-alt="topic.hero.imageAlt"
    />

    <section class="w-11/12 mx-auto my-16 lg:w-5/6">
      <MachinerySectionTitle v-reveal class="reveal" :title="topic.sectionTitle" />

      <div class="grid gap-6 mt-10 sm:grid-cols-2 lg:grid-cols-3">
        <IconTextCard
          v-for="(card, index) in topic.cards"
          :key="card.title"
          v-reveal="index"
          class="reveal"
          :icon="card.icon"
          :title="card.title"
          :text="card.text"
        />
      </div>
    </section>

    <section class="w-11/12 mx-auto my-16 lg:w-5/6">
      <!-- Desktopon a rés a galérián belüli képek közeivel azonos. -->
      <div class="grid gap-8 lg:grid-cols-2 lg:gap-4">
        <MachineryReferences v-reveal boxed class="reveal reveal-left" :references="topic.references" />
        <MachineryGallery :images="topic.references.gallery" />
      </div>
    </section>

    <!-- Esettanulmányok: a locale `caseStudies` tömbje egyelőre üres; ha a
         partner anyaga megjön, a szekció kódmódosítás nélkül bekapcsol. -->
    <section v-if="topic.caseStudies.length" class="w-11/12 mx-auto my-12 lg:w-5/6">
      <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <div
          v-for="(study, index) in topic.caseStudies"
          :key="study.title"
          v-reveal="index"
          class="reveal bg-light-grey rounded-2xl p-6 text-left"
        >
          <h3 class="InterExtraBold text-lg">{{ study.title }}</h3>
          <p class="InterMedium mt-3 text-base">{{ study.text }}</p>
        </div>
      </div>
    </section>

    <CtaBanner
      :title="topic.cta.title"
      :text="topic.cta.text"
      :button-text="topic.cta.button"
    />

    <!-- A ContactUsPage gyökérelemén már ott van az id="enquiry" (a CtaBanner
         erre scrollol), a címet/alcímet pedig maga olvassa a locale cup2/cup3
         kulcsaiból — nincs title/subtitle propja. -->
    <ContactUsPage
      contact-phone="06 20 485 0585"
      contact-email="lukacs.csaba@poliol.hu"
      contact-topic="general"
      class="mt-12"
    />
    <FooterComp />
  </div>
</template>
